import { render, staticRenderFns } from "./OrthoFootOrthotics.vue?vue&type=template&id=dbcf9c7e&scoped=true"
import script from "./OrthoFootOrthotics.vue?vue&type=script&lang=js"
export * from "./OrthoFootOrthotics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcf9c7e",
  null
  
)

export default component.exports